
// import Swiper from 'swiper';
// import SwiperCore, { Navigation, Pagination } from 'swiper/core';

class Termekreceptajanlo2024 {

    constructor() {

        this.carouselBrakepoints = {
            380: {
                spaceBetween: 0,
                slidesPerView: 1,
                slidesPerGroup: 1,
            },
            580: {
                spaceBetween: 15,
                slidesPerView: 3,
                slidesPerGroup: 3
            },
            980: {
                spaceBetween: 15,
                slidesPerView: 5,
                slidesPerGroup: 5
            },
            1200: {
                spaceBetween: 15,
                slidesPerView: 5,
                slidesPerGroup: 5
            }
        };
        this.init();
    }

    init() {

        if ($('.termek-receptajanlo-2024').length > 0)
        {
            $.each($('.termek-receptajanlo-2024'), (ii, tItem) => {

                let baseID = $(tItem).attr('id').replace('instance_', '');

                this.basePanel = $('#' + baseID);

                this.initCarousel(baseID)
            });
        }
    }

    initCarousel (baseID)
    {
        if ($('.termek-receptajanlo-2024#instance_' + baseID + ' .carousel-strip').length > 0)
        {
            $('.termek-receptajanlo-2024#instance_' + baseID + ' .carousel-strip-wrapper').css(
                'width',
                (window.innerWidth - $('.termek-receptajanlo-2024#instance_' + baseID + ' .carousel-wrap').offset().left) +'px'
            );

            if (aktReceptekData && aktReceptekData.length > 0)
            {
                let htmlTemplate = '';

                $.each(aktReceptekData, (ii, item) => {
                    htmlTemplate += '<div class="swiper-slide ritem">';
                    htmlTemplate += '<a href="' + item.url + '">';
                    htmlTemplate += '<div class="carousel-item-image">';
                    htmlTemplate += '<img src="' + item.image + '" alt="' + item.nev + '">';
                    htmlTemplate += '</div>';
                    htmlTemplate += '<div class="carousel-item-title">';
                    htmlTemplate += item.nev;
                    htmlTemplate += '</div>';
                    htmlTemplate += '</a>';

                    if (item.has_video)
                    {
                        htmlTemplate += '<span class="video-popup-link in-short">video</span>';
                    }

                    htmlTemplate += '</div>';
                });

                $('.termek-receptajanlo-2024#instance_' + baseID + ' .carousel-strip').empty().append(htmlTemplate);

                new Swiper('.termek-receptajanlo-2024#instance_' + baseID + ' .carousel-strip-wrapper', {
                    slidesPerView: 'auto',
                    // slidesPerGroup: 1,
                    spaceBetween: 24,
                    scrollbar: {
                        enabled: true,
                        el: '.termek-receptajanlo-2024#instance_' + baseID + ' .swiper-scrollbar',
                        hide: false,
                    },
                    loop: true,
                    // autoplay: {
                    //     delay: 7000
                    // },
                    // breakpoints: this.carouselBrakepoints,
                    navigation: {
                        nextEl: '.termek-receptajanlo-2024#instance_' + baseID + ' .carousel-control .control-right',
                        prevEl: '.termek-receptajanlo-2024#instance_' + baseID + ' .carousel-control .control-left',
                    }
                });
            }

            if (typeof osszesReceptUrl !== 'undefined') {
                $('.termek-receptajanlo-2024#instance_' + baseID + ' a.osszes-recept').attr('href', osszesReceptUrl);
            }

            if (typeof osszesReceptNumber !== 'undefined') {
                $('.termek-receptajanlo-2024#instance_' + baseID + ' .recnum-display').text(osszesReceptNumber);
                if (+osszesReceptNumber > 0)
                {
                    $('.termek-receptajanlo-2024#instance_' + baseID).removeClass('d-none');
                }
            }

            if (typeof aktTermeknev !== 'undefined') {
                $('.termek-receptajanlo-2024#instance_' + baseID + ' .termeknev').html(aktTermeknev);
            }
        }
    }

}

export default Termekreceptajanlo2024;

